<style lang="scss" scoped src="./style/index.scss"></style>
<template>
    <div
        class="plugin-mold flex flex-center"
        :class="{cursor: type === 'easy'}"
        @click="goTo">
        <!-- <svg-i :icon="icon"></svg-i> -->
        <img class="img-icon" :src="icon">
        <template v-if="type === 'easy'">
            <p class="special-msg" v-if="msg">{{msg}}</p>
        </template>
        <template v-if="type === 'medium'">
            <p class="msg" v-if="msg">{{msg}}</p>
            <router-link :to="link" style="text-align: center;">
                <el-button
                    class="btnMsg"
                    size="small"
                    :type="btnType"
                    :round="btnRound"
                    v-if="btnMsg">
                    {{btnMsg}}
                </el-button>
            </router-link>
        </template>
        <template v-if="type === 'difficulty'">
            <p class="title" v-if="title">{{title}}</p>
            <p class="msg" v-if="msg">{{msg}}</p>
            <router-link :to="link">
                <el-button
                    class="btnMsg"
                    size="small"
                    :type="btnType"
                    :round="btnRound"
                    v-if="btnMsg">
                    {{btnMsg}}
                </el-button>
            </router-link>
        </template>
    </div>
</template>
<script>
/*
 *type 类型
 * easy('简易')
 * medium('中等')
 * difficulty('困难')
 */
export default {
  name: 'pluginMold',
  props: {
    icon: {
      type: String,
    },
    title: {
      type: String,
    },
    msg: {
      type: String,
    },
    btnMsg: {
      type: String,
    },
    type: {
      type: String,
      default: 'easy',
    },
    btnType: {
      type: String,
      default: 'primary',
    },
    btnRound: {
      type: Boolean,
      default: true,
    },
    link: {
      type: String,
      default: '/',
    },
  },
  methods: {
    goTo() {
      if (this.type === 'easy') {
        if (this.link.indexOf('http') === -1) {
          this.$router.push(this.link);
        } else {
          window.open(this.link);
        }
      }
    },
  },
};

</script>
